import { Component, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { PredictorModelState } from '../../../state/predictor-model/predictor-model.state';
import { SimulationTrackerState } from '../../../state/simulation-tracker/simulation-tracker.state';
import { SimulationTrackerStatus } from '../../enums/simulation-tracker-status';
import { AgentSettings } from '../../interfaces/agent-settings';
import { SimulationTracker } from '../../interfaces/simulation-tracker';
import { StudyArea } from '../../interfaces/study-area';
import { SimulationLoopService } from '../../services/simulation-loop.service';
import { SimulationTrackerDataService } from '../../services/simulation-tracker-data.service';
import { SimulationService } from '../../services/simulation.service';

@Component({
  selector: 'app-simulation-tracker-result-column',
  templateUrl: './simulation-tracker-result-column.component.html',
  styleUrl: './simulation-tracker-result-column.component.scss',
})
export class SimulationTrackerResultColumnComponent implements OnDestroy {
  @Select(SimulationTrackerState.selectedSimulationTrackerAgentSettings)
  agentSettings$!: Observable<AgentSettings | null>;

  @Select(SimulationTrackerState.selectedSimulationTracker)
  simulationTracker$!: Observable<SimulationTracker | null>;

  @Input() resultsSimulationId!: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Select(PredictorModelState.terrainLoaded)
  terrainLoaded$!: Observable<boolean | null>;

  @Select(PredictorModelState.selectedStudyArea)
  selectedStudyArea$!: Observable<StudyArea | null>;

  @Select(SimulationTrackerState.selectedSimulationTrackerScenariosDropdowns)
  scenarios$!: Observable<any[]>;

  constructor(
    public simulationLoopService: SimulationLoopService,
    public simulationService: SimulationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  selectedSimulationTracker: SimulationTracker | null = null;

  trackerChange(event: { originalEvent: Event; value: SimulationTracker }) {
    this.router.navigate(['../', event.value.simulationTrackerId], {
      relativeTo: this.route,
    });
  }

  trackerStatus: typeof SimulationTrackerStatus = SimulationTrackerStatus;

  /**
   * Gets the theme for the given simulation tracker status.
   * @param status The simulation tracker status.
   * @returns The theme associated with the status.
   */
  getStatusTheme(status: SimulationTrackerStatus): string {
    return SimulationTrackerDataService.GetStatusTheme(
      SimulationTrackerDataService.SimulationTrackerStatusMap[status]
    );
  }

  /**
   * Gets the status as a string.
   * @param status The simulation tracker status.
   * @returns The status as a string.
   */
  getStatus(status: SimulationTrackerStatus): string {
    return SimulationTrackerDataService.SimulationTrackerStatusMap[status];
  }

  /**
   * Gets the icon for the given simulation tracker status.
   * @param status The simulation tracker status.
   * @returns The icon associated with the status.
   */
  getStatusIcon(status: SimulationTrackerStatus): string {
    return SimulationTrackerDataService.GetStatusIcon(
      SimulationTrackerDataService.SimulationTrackerStatusMap[status]
    );
  }
}
